module.exports = __webpack_public_path__ + "img/img2.38544bbf.svg";